import AppBar from './components/AppBar';
import Hero from './components/Hero';
import Services from './components/Services';
import Statistics from './components/Statistics';
import Media from './components/Media';
import Footer from './components/Footer';
import Team from './components/Team';
import Testimonial from './components/Testimonial';
import Introduction from './components/Introduction';
import Contact from './components/Contact';

import './styles/Common.css';
import Partners from './components/Partners';

function App() {
  return (
    <>
      <AppBar />
      <Hero id="home" />
      <Statistics id="stats"/>
      <Introduction id="introudtion"/>
      <Team id="team"/>
      <Services id="services"/>
      <Media id="news"/>
      <Testimonial id="testimonial"/>
      <Partners id="partner"/>
      <Contact id="contact"/>
      <Footer/>
    </>
  );
}

export default App;
